import { FC } from "react";
import PropTypes from "prop-types";
import { Field, useFormikContext } from "formik";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox,
  CheckboxProps,
} from "@mui/material";

type CheckboxFieldProps = CheckboxProps & {
  name: string;
  label: string;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  handleChange?: (e: any) => void;
};

const CheckboxField: FC<CheckboxFieldProps> = (props) => {
  const { setFieldValue } = useFormikContext();
  const {
    name,
    label,
    helperText,
    required = false,
    disabled = false,
    readOnly = false,
    handleChange = (event) => {
      setFieldValue(event.target.name, event.target.checked);
    },
  } = props;

  return (
    <Field name={name}>
      {({ field, form }) => (
        <FormControl error={form.errors[name] && form.touched[name]} required={required}>
          <FormControlLabel
            control={
              <Checkbox
                {...props}
                {...field}
                disabled={disabled || readOnly}
                checked={field.value}
                onChange={handleChange}
              />
            }
            label={label}
          />
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      )}
    </Field>
  );
};

CheckboxField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  handleChange: PropTypes.func,
};

export default CheckboxField;
